import { render, staticRenderFns } from "./Coding.vue?vue&type=template&id=f46c8164&scoped=true&lang=html&"
import script from "./Coding.vue?vue&type=script&lang=js&"
export * from "./Coding.vue?vue&type=script&lang=js&"
import style0 from "./Coding.vue?vue&type=style&index=0&id=f46c8164&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46c8164",
  null
  
)

export default component.exports